module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0154.jpg?v=1302b8cd";